import ListGroup from "react-bootstrap/ListGroup";
import {
  EmailShareButton,
  FacebookShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailIcon,
  FacebookIcon,
  TelegramIcon,
  TwitterIcon,
  WhatsappIcon,
} from "react-share";

import "./Product.css";

const ShareModal = ({ link }) => {
  return (
    <>
      <ListGroup variant="flush">
        <EmailShareButton url={link} className="w-100 text-start share-button">
          <ListGroup.Item className="share-button border-0">
            <EmailIcon size={32} />
            <span className="ms-2 fs-14">Share on Email</span>
          </ListGroup.Item>
        </EmailShareButton>
        <FacebookShareButton url={link} className="w-100 text-start share-button">
          <ListGroup.Item className="share-button border-0">
            <FacebookIcon size={32} />
            <span className="ms-2 fs-14">Share on Facebook</span>
          </ListGroup.Item>
        </FacebookShareButton>
        <TwitterShareButton url={link} className="w-100 text-start share-button">
          <ListGroup.Item className="share-button border-0">
            <TwitterIcon size={32} />
            <span className="ms-2 fs-14">Share on Twitter</span>
          </ListGroup.Item>
        </TwitterShareButton>
        <WhatsappShareButton url={link} className="w-100 text-start share-button">
          <ListGroup.Item className="share-button border-0">
            <WhatsappIcon size={32} />
            <span className="ms-2 fs-14">Share on Whatsapp</span>
          </ListGroup.Item>
        </WhatsappShareButton>
        <TelegramShareButton url={link} className="w-100 text-start share-button">
          <ListGroup.Item className="share-button border-0">
            <TelegramIcon size={32} />
            <span className="ms-2 fs-14">Share on Telegram</span>
          </ListGroup.Item>
        </TelegramShareButton>
      </ListGroup>
    </>
  );
};

export default ShareModal;
